exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".radio{margin:.5rem}.radio input[type=radio]{position:absolute;opacity:0}.radio input[type=radio]+label:before{content:\"\";background:#f4f4f4;border-radius:100%;border:1px solid #b4b4b4;display:inline-block;width:1.4em;height:1.4em;position:relative;top:-0.2em;margin-right:1em;vertical-align:top;cursor:pointer;text-align:center;transition:all 250ms ease}.radio input[type=radio]:checked+label:before{background-color:#005d82;box-shadow:inset 0 0 0 4px #f4f4f4}.radio input[type=radio]:focus+label:before{outline:none;border-color:#005d82}.radio input[type=radio]:disabled+label:before{box-shadow:inset 0 0 0 4px #f4f4f4;border-color:#b4b4b4;background:#b4b4b4}.radio input[type=radio]+label:empty:before{margin-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/ec2-user/esquina/esquina/node_modules/css-loader!/home/ec2-user/esquina/esquina/node_modules/sass-loader/dist/cjs.js!/home/ec2-user/esquina/esquina/lib/frontend/components/marble-form/radio-widget/base.scss
// module id = 225
// module chunks = 0